// extracted by mini-css-extract-plugin
export default {"loading-pulse":"components-hotel-reviews-review-card-loading-module__loading-pulse","pulse":"components-hotel-reviews-review-card-loading-module__pulse"};